export default {
  textarea: {
    height: 100,
    marginTop: 10,
    marginBottom: 10,
    outline: 'none',
    resize: 'none'
  }
};
